import React from 'react';
import { List } from '@material-ui/core';
import { RosterListItem, RosterStatus } from '../main-section/roster/roster-types';
import { RosterItem } from './RosterItem';
import { useBatchRosterStatus } from './useBatchRosterStatus';

interface RosterListProps {
  rosters: RosterListItem[];
  refetchTrigger?: number;
}

export const RostersList = (props: RosterListProps) => {
  const { rosters, refetchTrigger } = props;

  const { data: statusData, isLoading } = useBatchRosterStatus(rosters, refetchTrigger);

  return (
    <List>
      {rosters.map((r) => {
        const statusKey = `${r.activityId}-${r.activityDate}`;
        const status = (statusData[statusKey] as RosterStatus) || 'neutral';

        return <RosterItem key={statusKey} roster={r} rosterStatus={status} loading={isLoading} />;
      })}
    </List>
  );
};
